import { setIsRefreshModalOpen, incrementIframeReloadCount } from '@/state/features/app';
import { useAppDispatch, useAppSelector } from '@/state/store';
import Modal from '@/components/Modal';
import ThemedButton from '@/components/ThemedButton';

export default function RefreshModal() {
    const dispatch = useAppDispatch();
    const isRefreshModalOpen = useAppSelector((state) => state.app.isRefreshModalOpen);

    const handleRefresh = () => {
        dispatch(incrementIframeReloadCount());
        dispatch(setIsRefreshModalOpen(false));
        document.documentElement.requestFullscreen().catch(() => {
            console.log('[Arise Debug] Request fullscreen failed');
        });
    };

    return (
        <Modal
            title="Are you sure you want to refresh?"
            onClose={() => {
                dispatch(setIsRefreshModalOpen(false));
            }}
            isVisible={isRefreshModalOpen}
        >
            <ThemedButton text="Refresh" onClick={handleRefresh} disabled={!isRefreshModalOpen} />
        </Modal>
    );
}
